import styled from 'styled-components'

export const SearchBarContainer = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  background-color: color-mix(
    in oklch,
    ${({ theme }) => theme.forecast.pageBackground1},
    transparent 20%
  );
  backdrop-filter: blur(2rem);
  -webkit-backdrop-filter: blur(2rem);
  border-radius: 0.25rem;
  box-shadow: 0 2px 8px ${({ theme }) => theme.forecast.boxShadow};
`

export const SearchInput = styled.input`
  width: 200px;
  padding: 0.25rem 0.5rem;
  border: 1px solid ${({ theme }) => theme.forecast.border};
  border-radius: 0.25rem;
  background-color: ${({ theme }) => theme.forecast.background2_5};
  color: ${({ theme }) => theme.forecast.activeText};
  font-size: 13px;
  outline: none;
  transition: border-color 0.2s ease;

  &::placeholder {
    color: ${({ theme }) => theme.forecast.secondaryText};
  }

  &:focus {
    border-color: ${({ theme }) => theme.forecast.activeButton};
  }
`

export const SpinningIcon = styled.span`
  display: inline-flex;
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  animation: spin 1s linear infinite;
`

export const MatchCount = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.forecast.secondaryText};
  white-space: nowrap;
  min-width: 60px;
  text-align: center;
`
